import keyMapping from './keyMapping';
import assets from './assets';
import view from './view';

export default {
  keyMapping,
  view,
  assets,
};



// WEBPACK FOOTER //
// ./src/config/index.js